<button
  type="button"
  (click)="onClick($event)"
  [routerLink]="routerLink()"
  [queryParams]="queryParams()"
  routerLinkActive="active-button"
  [routerLinkActiveOptions]="{ exact: false }"
  [attr.aria-label]="collapsed() ? label() : null"
  [title]="collapsed() ? label() : null"
  class="text-base-content/85 rounded-r-none! cursor-pointer px-2.5 py-2 flex items-center w-full
         hover:bg-primary-100/5 hover:border-r-primary/50 border-r-transparent border-r-4
         hover:bg-linear-to-r hover:from-primary/5 hover:to-transparent
         focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-[-2px]
         motion-reduce:transition-none"
  [class.justify-start]="!collapsed()"
  [class.justify-center]="collapsed()"
  [class.flex-row]="!collapsed()"
  [class.flex-col]="collapsed()">
  <span class="material-symbols-outlined" aria-hidden="true">{{ icon() }}</span>
  @if (!collapsed()) {
  <span class="ml-4">{{ label() }}</span>
  }
</button>